module.exports = __webpack_public_path__ + "static/media/kredyt_36.9a26e493.png";